import { Component, OnInit, OnDestroy, Input, IterableDiffers, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'zoomable-container',
    templateUrl: './zoomable-container.component.html',
    styleUrls: ['./zoomable-container.scss']
})
export class ZoomableContainerComponent implements OnInit, OnDestroy {
    zoomButtonStyle: any;
    zoomContainerStyle: any = {};
    zoomActive = false;

    @ViewChild('zoomableContainerRoot') rootEl: ElementRef;

    @Input() zoomButtonPosition = "ne";
    @Input() zoomButtonVerticalShift: string = null;
    @Input() zoomButtonHorizontalShift: string = null;

    constructor() {
    }

    ngOnInit(): void {
        this.zoomButtonStyle = {
            "width": "40px",
            "height": "30px",
            "background-color": "#ff7514",
            "border-color": "#ff7514"
        };

        if (this.zoomButtonPosition === 'nw') {
            this.zoomButtonStyle['left'] = this.zoomButtonHorizontalShift || '0px';
            this.zoomButtonStyle['top'] = this.zoomButtonVerticalShift || '0px';
        } else if (this.zoomButtonPosition === 'ne') {
            this.zoomButtonStyle['right'] = this.zoomButtonHorizontalShift || '0px';
            this.zoomButtonStyle['top'] = this.zoomButtonVerticalShift || '0px';
        } else if (this.zoomButtonPosition === 'se') {
            this.zoomButtonStyle['right'] = this.zoomButtonHorizontalShift || '0px';
            this.zoomButtonStyle['bottom'] = this.zoomButtonVerticalShift || '0px';
        } else if (this.zoomButtonPosition === 'sw') {
            this.zoomButtonStyle['left'] = this.zoomButtonHorizontalShift || '0px';
            this.zoomButtonStyle['top'] = this.zoomButtonVerticalShift || '0px';
        }
    }

    zoomOn(): void {
        this.zoomActive = true;

        let originalW: number = this.rootEl.nativeElement.clientWidth;
        let originalH: number = this.rootEl.nativeElement.clientHeight;
        let viewW: number = document.documentElement.clientWidth;
        let viewH: number = document.documentElement.clientHeight;

        let scale = Math.min(viewW / originalW, viewH / originalH);

        let targetW = originalW * scale;
        let targetH = originalH * scale;

        let targetVmargin = ((viewH - targetH + (targetH * 5 / 100)) / 2);
        let targetHmargin = ((viewW - targetW + (targetW * 5 / 100)) / 2);

        this.zoomContainerStyle = {
            "top": `${targetVmargin}px`,
            "bottom": `${targetVmargin}px`,
            "left": `${targetHmargin}px`,
            "right": `${targetHmargin}px`,
        };
    }

    zoomOff(): void {
        this.zoomActive = false;
        this.zoomContainerStyle = {};
    }

    ngOnDestroy(): void { }

}
